"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const MapSideBarPanelFields_vue_1 = __importDefault(require("./MapSideBarPanelFields.vue"));
const MapSideBarNavigationRight_vue_1 = __importDefault(require("./MapSideBarNavigationRight.vue"));
let MapSideBar = class MapSideBar extends vue_property_decorator_1.Vue {
    focusField(field) {
        this.$emit('focusField', field);
    }
    mainActionClicked(field) {
        this.$emit('mainActionClicked', field);
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    changePanel(p) {
        this.$emit('changePanel', p);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], MapSideBar.prototype, "activePanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBar.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], MapSideBar.prototype, "currentProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], MapSideBar.prototype, "isRendering", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], MapSideBar.prototype, "fieldActiveKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], MapSideBar.prototype, "isLoadingOpenReport", void 0);
MapSideBar = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarNavigationRight: MapSideBarNavigationRight_vue_1.default,
            MapSideBarPanelFields: MapSideBarPanelFields_vue_1.default
        },
    })
], MapSideBar);
exports.default = MapSideBar;
